module.exports = __webpack_public_path__ + "static/media/2_pl.5c27d3dc.png";